export default "__VITE_ASSET__8286e579__"